




























































import { Prop, Component, Vue } from "vue-property-decorator";
import _, { cloneDeep } from "lodash";
import { addDays, eachDayOfInterval } from "date-fns";

import endOfDuration from "../helpers/endOfDuration";
import formatDate from "../helpers/formatDate";

import Action from "../models/action";
import User from "../models/user";
import Chart from "../models/chart";
import ChartRow from "../models/chart-row";
import ChartBar from "../models/chart-bar";
import chartBarFactory from "../models/factories/chart-bar-factory";
import { CalendarLike, Keys as CalendarKeys } from "@/models/calendar-like";
import ProjectMember from "../models/project-member";
import publicHolidayCalendar from "../models/public-holiday-calendar";
import ProjectTaskBar from "../models/project-task-bar";

import { TaskGroup, Task, newTask } from "../api/task-api";
import { getRokuyo } from "../api/rokuyo-api";
import TaskFormData from "../api/models/TaskFormData";
import ITaskOutputOptions from "../api/models/ITaskOutputOptions";
import TaskGroupFormData from "../api/models/TaskGroupFormData";
import { TaskType, getTaskTypesOfProject } from "../api/task-type-api";
import { getWeatherNews, WeatherNews } from "../api/weather-api";
import { getPublicHolidays } from "../api/holiday-api";

import ProjectChartTemplate from "@/templates/ProjectChartTemplate.vue";
import TaskEditModal from "../templates/TaskEditModal.vue";
import TaskGroupShowModal from "../templates/TaskGroupShowModal.vue";
import TaskGroupEditModal from "../templates/TaskGroupEditModal.vue";
import VInviteModal from "../components/VInviteModal.vue";
import Vendor from "@/usecases/models/vendor";
import VendorGateway from "../usecases/gateways/vendor-gateway";
import VendorStaffGateway from "../usecases/gateways/vendor-staff-gateway";
import VendorStaff from "../models/vendor-staff";
import ChartTaskPolicy from "../entities/chart-task-policy";
import BarColor from "@/presenters/models/bar-color";

import ScheduleEventListModal from "@/ui/schedule/pages/ScheduleEventListModal.vue";
import NewScheduleEventModal from "../ui/schedule/pages/NewScheduleEventModal.vue";
import EditScheduleEventModal from "../ui/schedule/pages/EditScheduleEventModal.vue";
import ScheduleCalendarApi from "../api/schedule/schedule-calendar-api";
import { client } from "@/api/request";
import ScheduleViewModel from "@/ui/schedule/presenters/schedule";
import TaskModal from "./TaskModal.vue";
import TaskTemplateAppendModal from "../templates/TaskTemplateAppendModal.vue";
import TaskSaveTemplateModal from "../templates/TaskSaveTemplateModal.vue";
// // TODO: 親画面側の関数で追加したほうがいい？
import { ConcretizedPlan, addTasksFromConcretizedPlan } from "../api/task-api";
import emitter from "@/EventBus";
import Service from "@/models/service";
import Client from "@/api/client";
import { axios } from "@/api/axios";
import { getProject, Project } from "@/api/project-api";

const scheduleCalendarApi = new ScheduleCalendarApi(client);

@Component({
  components: {
    TaskModal,
    ProjectChartTemplate,
    TaskEditModal,
    TaskGroupShowModal,
    TaskGroupEditModal,
    TaskTemplateAppendModal,
    VInviteModal,
    ScheduleEventListModal,
    NewScheduleEventModal,
    EditScheduleEventModal,
    TaskSaveTemplateModal
  }
})
export default class ProjectChartPage extends Vue {
  @Prop({ required: true }) projectId!: string;

  initTask!: Task | null;
  taskUpdated: boolean = false;
  /* ツールバー */

  get toolbarActions(): Action[] {
    const actions: Action[] = [];
    if (
      this.user.can("service/project_operation") ||
      this.user.can("project/document_secret") ||
      (this.user.can("project/task_operation") &&
        this.user.can("service/master_read"))
    ) {
      actions.push({
        key: "saveTemplateTask",
        icon: "mdi-plus",
        text: "工程プランを保存",
        variant: "default",
        click: () => {
          this.saveTemplateTask();
        }
      });

      if (this.inEdit) {
        actions.push({
          key: "appendPlan",
          icon: "mdi-plus",
          text: "工程プランを追加",
          variant: "default",
          click: () => {
            this.appendPlan();
          }
        });
      }
    }

    /* BRV-340 remove button*/
    // if (this.scheduleFilter === "me") {
    //   actions.push({
    //     key: "expandSchedule",
    //     icon: "",
    //     text: "予定表展開",
    //     variant: "default",
    //     click: () => {
    //       this.scheduleFilter = "all";
    //     }
    //   });
    // } else {
    //   actions.push({
    //     key: "collapseSchedule",
    //     icon: "",
    //     text: "折りたたむ",
    //     variant: "secondary",
    //     click: () => {
    //       this.scheduleFilter = "me";
    //     }
    //   });
    // }
    if (
      this.user.can("service/project_operation") ||
      this.user.can("project/document_secret") ||
      (this.user.can("project/task_operation") &&
        this.user.can("service/master_read")) ||
      this.canEdit
    ) {
      if (this.inEdit) {
        actions.push({
          key: "show",
          icon: "",
          text: "終了",
          variant: "primary",
          click: () => {
            this.show();
          }
        });
      } else {
        actions.push({
          key: "edit",
          icon: "",
          text: "編集",
          variant: "default",
          click: () => {
            this.edit();
          }
        });
      }
    }
    return actions;
  }

  /* 編集モードの切り替え */

  inEdit = false;

  edit() {
    this.inEdit = true;
  }

  show() {
    this.inEdit = false;
  }

  /* チャート */

  baseDate = new Date();
  chart = new Chart(this.baseDate, 10);

  get rows(): ChartRow[] {
    const policy = new ChartTaskPolicy(this.chart);
    return this.taskGroups.map(g => ({
      id: g.taskGroupId,
      label: this.getTaskRowLabel(g),
      actions: this.getTaskGroupActions(g),
      bars: g.tasks.filter(t => policy.isSatisfied(t)).map(this.createTaskBar),
      staffId: g.staff && g.staff.staffId
    }));
  }

  get rowAppendable(): boolean {
    return (
      this.inEdit &&
      (this.user.can("project/document_secret") ||
        this.user.can("service/project_operation"))
    );
  }

  async goNext() {
    await this.moveChart(1);
  }

  async goPrev() {
    await this.moveChart(-1);
  }

  private async moveChart(step: number) {
    const ps: Promise<void>[] = [];
    const defaultMoveStep = 14;
    let movement = defaultMoveStep;
    if (this.chart.cols < defaultMoveStep) {
      movement = this.chart.cols;
    }
    // for (let i = 1; i <= this.movement; i++) {
    for (let i = 1; i <= movement; i++) {
      ps.push(
        new Promise(resolve => {
          setTimeout(() => {
            this.chart.move(step);
            resolve();
          }, 7 * i);
        })
      );
    }
    await Promise.all(ps);
    this.initRokuyo();
    this.initHoliday();
    this.initScheduleCalendarList();
  }

  /* チャートのヘッダ */

  private headerType: "weather" | "rokuyo" = "weather";

  get chartHeader() {
    return {
      type: this.headerType,
      days: this.days,
      rokuyoDays: this.rokuyoDays,
      weatherDays: this.weatherDays
    };
  }

  toggleHeaderType() {
    if (this.headerType === "weather") {
      this.headerType = "rokuyo";
    } else {
      this.headerType = "weather";
    }
  }

  private get days(): Date[] {
    return eachDayOfInterval(this.chart);
  }

  /* 列数の自動調整 */

  resize(width: number) {
    // 先にresizeされるのを防ぐためにsettimeout
    setTimeout(() => {
      this.chart.adjust(width);
      this.initRokuyo();
      this.initHoliday();
      this.initScheduleCalendarList();
    }, 100);
  }

  /* 工程 */

  task: Task | null = null;
  taskOpen = false;
  service: Service | undefined;

  get serviceInfo() {
    return this.service;
  }

  get client() {
    return new Client(axios);
  }

  async getService(currentServiceId: number) {
    const userServices = await this.client.get("get_user_services.php");
    if (userServices) {
      this.service = userServices.find(
        (
          s: Service & {
            createdDate?: string;
            currentMonthAppUsers?: number;
            lastMonthAppUsers?: number;
            serviceChart?: boolean;
            users?: number;
          }
        ) => s.id === currentServiceId
      );
    }
  }

  async selectTask(tid: number) {
    const task = this.tasks.find(t => t.taskId === tid);
    const tg = this.taskGroups.find(
      item => item.taskGroupId == (task && task.taskGroupId)
    ) as any;
    if (!task) return;
    if (
      this.inEdit &&
      (this.canCreateTask || this.currentUser.staffId == (tg && tg.staffId))
    ) {
      this.editTask(task);
    } else {
      this.showTask(task);
    }
  }

  newTask(gid: number, start: Date = this.chart.start) {
    if (!this.inEdit || !this.canCreateTask) return;
    const group = this.taskGroups.find(g => g.taskGroupId === gid);
    const name = group ? group.taskType : "";
    this.task = newTask(gid, name, start);
    (this.$refs.taskEditModal as TaskEditModal).show();
  }

  get canCreateTask() {
    return this.currentUser.hasRole;
  }

  showTask(task: Task) {
    this.task = task;
    this.taskOpen = true;
  }

  editTask(task: Task) {
    // clone for cancel
    this.task = {
      ...task,
      closedDays: task.closedDays,
      subTasks: task.subTasks.map(t => ({ ...t }))
    };
    this.initTask = cloneDeep(this.task);
    (this.$refs.taskEditModal as TaskEditModal).show();
  }

  async updateTask(
    task: Task,
    options: ITaskOutputOptions = { hasClosedDays: true, hasSubTasks: true }
  ) {
    let changed = false;
    if (this.initTask) {
      changed =
        new Date(task.start).getTime() !==
          new Date(this.initTask.start).getTime() ||
        new Date(task.end).getTime() !== new Date(this.initTask.end).getTime();
    }
    const d = TaskFormData(task, options);

    const shouldNotify =
      this.serviceInfo &&
      this.serviceInfo.scheduleNotification &&
      (changed || this.taskUpdated);

    let confirmed = false;
    if (shouldNotify && task.taskId) {
      if (this.onMobile) {
        confirmed = await this.$bvModal.msgBoxConfirm(
          "この工程変更をチャットへ通知します。よろしいですか？",
          {
            title: "確認",
            okTitle: "はい",
            cancelTitle: "いいえ",
            noCloseOnBackdrop: true
          }
        );
      } else {
        confirmed = confirm(
          "この工程変更をチャットへ通知します。よろしいですか？"
        );
      }
    }

    if (shouldNotify && confirmed) {
      d.append("notify", "1");
    }

    this.taskUpdated = false;
    this.initTask = null;
    await this.$store.dispatch("saveTask", d);
  }

  async deleteTask(task: Task) {
    if (!confirm("本当に工程を削除しますか？")) return;
    await this.$store.dispatch("deleteTask", task.taskId);
  }

  moveTask(bar: ChartBar) {
    this.task = this.tasks.find(t => t.taskId === bar.id) || null;
    if (!this.task) return;
    const start = addDays(this.chart.start, bar.start);
    const end = endOfDuration(start, bar.span);
    Object.assign(this.task, { start, end, duration: bar.span });
  }

  submitTaskMove() {
    if (this.task) {
      this.updateTask(this.task);
    }
  }

  cancelTaskMove() {
    this.getProjectTasks();
  }

  /* 工程行 */

  taskGroup: TaskGroup | null = null;

  newTaskGroup() {
    this.$store.dispatch("addNewTaskGroup");
  }

  showTaskGroup(taskGroup: TaskGroup) {
    this.taskGroup = taskGroup;
    (this.$refs.taskGroupShowModal as any).show();
  }

  editTaskGroup(taskGroup: TaskGroup) {
    // clone for cancel
    this.taskGroup = { ...taskGroup };
    (this.$refs.taskGroupEditModal as any).show();
  }

  async updateTaskGroup(taskGroup: TaskGroup) {
    const d = TaskGroupFormData(taskGroup);
    await this.$store.dispatch("saveTaskGroup", d);
  }

  async deleteTaskGroup(taskGroup: TaskGroup) {
    let message = "本当に工程を削除しますか？";
    if (taskGroup.tasks.some(item => item.subTasks.length)) {
      message = `タスクがあります。工程を削除するとタスクも削除されます。`;
    }

    if (!confirm(message)) return;
    await this.$store.dispatch("deleteTaskGroup", taskGroup.taskGroupId);
  }

  async sortTaskGroups(ids: number[]) {
    this.$store.dispatch(
      "sortTaskGroups",
      ids.map(id => this.taskGroups.find(t => t.taskGroupId === id))
    );
  }

  /* 工程プランから追加 */

  appendPlan() {
    (this.$refs.taskTemplateAppendModal as any).show();
  }

  saveTemplateTask() {
    (this.$refs.taskSaveTemplateModal as any).show();
  }

  async appendTasksFromConcretizedPlan(newTasks: ConcretizedPlan) {
    await addTasksFromConcretizedPlan(newTasks);
    this.getProjectTasks();
  }

  /* その他のデータ */

  taskTypes: TaskType[] = [];
  vendors: Vendor[] = [];
  vendorStaffs: VendorStaff[] = [];
  vendorServiceStaffs: VendorStaff[] = [];
  serviceDetail: Project & { serviceId?: number } | null = null;

  get user(): User {
    return this.$store.getters.user;
  }

  get members(): ProjectMember[] {
    return this.$store.state.projectMembers;
  }

  get taskGroups(): TaskGroup[] {
    return this.$store.state.task.taskGroups;
  }

  get tasks(): Task[] {
    return this.taskGroups.flatMap(g => g.tasks);
  }

  public created() {
    this.getProjectTasks();
    this.initRokuyo();
    this.initWeatherNews();
    this.initVendorList();
    this.initVendorStaffList();
    this.initTaskTypeList();
    this.initScheduleCalendarList();
    this.initVendorServiceStaffList();
    emitter.on("taskUpdated", () => {
      this.taskUpdated = true;
    });
    this.$store.dispatch("initProject", this.projectId);
  }

  async mounted() {
    let project = this.$store.state.project;
    if (!project) {
      await this.getProjectInfo();
      project = this.serviceDetail;
    }

    if (project && project.serviceId) {
      await this.getService(project.serviceId);
    }
  }

  private async getProjectInfo() {
    this.serviceDetail = await getProject(this.projectId);
  }

  private async getProjectTasks() {
    await this.$store.dispatch("getProjectTasks", this.projectId);
  }

  private async initTaskTypeList() {
    this.taskTypes = await getTaskTypesOfProject(this.projectId);
  }

  private get vendorApi(): VendorGateway {
    return this.$store.getters.vendorApi;
  }

  private get vendorStaffApi(): VendorStaffGateway {
    return this.$store.getters.vendorStaffApi;
  }

  private async initVendorList() {
    this.vendors = await this.vendorApi.findByProjectId(Number(this.projectId));
  }

  private async initVendorStaffList() {
    this.vendorStaffs = await this.vendorStaffApi.findByProjectId(
      Number(this.projectId)
    );
  }

  private async initVendorServiceStaffList() {
    this.vendorServiceStaffs = await this.vendorStaffApi.findByProjectId(
      Number(this.projectId)
    );
  }

  /* 六曜 */

  private rokuyoDays: string[] = [];
  private rokuyoCalender = new CalendarLike();

  private async initRokuyo() {
    const start = this.chart.start as Date;
    const end = this.chart.end as Date;
    const keys = CalendarKeys(start, end);
    await Promise.all(
      keys.map(async k => {
        if (this.rokuyoCalender.hasKey(k)) return;
        const days = await getRokuyo(k);
        this.rokuyoCalender.append(k, days);
      })
    );
    this.rokuyoDays = this.rokuyoCalender.get(start, end);
  }

  /* 天気 */

  private weatherNews: WeatherNews = {
    place: "",
    latitude: "",
    longitude: "",
    weatherNews: []
  };

  private get weatherDays(): string[] {
    const news = this.weatherNews.weatherNews;
    return this.days.map(d => {
      const w = news.find(w => w.date === formatDate(d));
      return w ? w.type : "";
    });
  }

  private async initWeatherNews() {
    this.weatherNews = await getWeatherNews(this.projectId);
  }

  /* 祝日 */

  // TODO 無駄に複雑すぎる気がする

  private holidays: string[] = [];

  private async initHoliday() {
    this.holidays = await publicHolidayCalendar.getDays(
      this.chart.start as Date,
      this.chart.end as Date,
      // holiday-api.ts でエラーが出ている
      _.partial(getPublicHolidays)
    );
  }

  private getHolidays(task: Task) {
    const bar = new ProjectTaskBar(task, this.chart);
    const holidays = eachDayOfInterval(bar).map(d =>
      task.closedDays.includes(d.getDay()) ? "休" : ""
    );
    const publicHolidays = task.closedDays.includes(7)
      ? this.holidays.slice(bar.startIndex, bar.startIndex + bar.span)
      : [];
    return _.zipWith(publicHolidays, holidays, (a, b) => (a || b ? "休" : ""));
  }

  /* その他のヘルパ */

  private getTaskRowLabelType(taskGroup: TaskGroup) {
    return taskGroup.taskType ? taskGroup.taskType : "業種未定";
  }

  private getTaskRowLabelCompanyName(taskGroup: TaskGroup) {
    if (taskGroup.company && taskGroup.office) {
      return `${taskGroup.company.name} ${taskGroup.office.name}`;
    }
    return "業者未定";
  }

  private getTaskRowLabelName(taskGroup: TaskGroup) {
    if (taskGroup.staff) {
      return taskGroup.staff.name;
    }
    return "作業者未定";
  }

  private getTaskRowLabel(taskGroup: TaskGroup) {
    const type = this.getTaskRowLabelType(taskGroup);
    const companyName = this.getTaskRowLabelCompanyName(taskGroup);
    const name = this.getTaskRowLabelName(taskGroup);
    return `${type}\n${companyName}\n${name}`;
  }

  private createTaskBar(t: Task): ChartBar {
    const b = chartBarFactory.create(t, this.chart);
    return {
      ...b,
      id: t.taskId,
      label: t.name,
      color: BarColor.fromTask(t).code,
      days: this.getHolidays(t)
    };
  }

  private getTaskGroupActions(t: TaskGroup): Action[] {
    if (this.inEdit && this.currentUser.hasRole) {
      const actions: Action[] = [];
      actions.push(
        new Action({
          key: "new",
          text: "追加",
          click: () => {
            this.newTask(t.taskGroupId);
          }
        })
      );
      actions.push(
        new Action({
          key: "edit",
          text: "編集",
          click: () => {
            this.editTaskGroup(t);
          }
        })
      );
      return actions;
    } else {
      return [
        new Action({
          key: "show",
          text: "詳細",
          click: () => {
            this.showTaskGroup(t);
          }
        })
      ];
    }
  }

  /* 予定 */

  rawScheduleCalendars: ScheduleViewModel[] = [];
  scheduleFilter: "me" | "all" = "me";

  get scheduleCalendars(): ScheduleViewModel[] {
    if (this.scheduleFilter === "all") {
      return this.rawScheduleCalendars;
    }
    return this.rawScheduleCalendars.filter(s => s.user.id === this.user.id);
  }

  clickScheduleCell(userId: number, date: Date) {
    (this.$refs.eventList as ScheduleEventListModal).show(userId, date);
  }

  createEvent(date: Date) {
    const pid = Number(this.projectId);
    (this.$refs.createEvent as NewScheduleEventModal).show(date, pid);
  }

  editEvent(id: number) {
    (this.$refs.editEvent as EditScheduleEventModal).show(id);
  }

  async initScheduleCalendarList() {
    const pid = Number(this.projectId);
    const calendars = await scheduleCalendarApi.findByPeriodAndProject(
      this.chart,
      pid
    );
    this.rawScheduleCalendars = calendars.map(
      c => new ScheduleViewModel(c, pid)
    );
  }

  get currentUser() {
    return this.$store.state.user;
  }

  get canEdit() {
    return this.currentUser.hasRole || this.currentUser.canModifyAssignedTasks;
  }

  get onMobile() {
    return this.$store.state.onMobile;
  }
}
